import GlobalBase from '../global-base';

/**
 * The JS controller for global scripts.
 */
class SharedHeader extends GlobalBase {

    docReady() {
        this.initMenuTogglers();
        this.initDropDownTogglers();
        this.initBannerHider();
    }

    initBannerHider() {
        const $closeIcon = document.getElementById( 'close-banner' );
        const $banner = document.getElementById( 'navbar-banner' );
        const $mainElement = document.getElementsByTagName('main')[0];

        if ( $banner ) {
            if (sessionStorage.getItem('hideBanner')) {
                $banner.style.display = "none";
            } else {
                $mainElement.style.cssText += 'padding-top: ' + $banner.offsetHeight + 'px'
            };
    
            $closeIcon.addEventListener( 'click', () => {
                $banner.style.display = "none";
                sessionStorage.setItem('hideBanner', "true");
                $mainElement.style.cssText += 'padding-top: 0px'
            });
        }
  


    }


    initMenuTogglers() {
        // Get all "navbar-burger" elements
        const $navbarBurgers = document.querySelectorAll( '.navbar-burger' );

        // Check if there are any navbar burgers
        if ( $navbarBurgers ) {

            // Add a click event on each of them
            $navbarBurgers.forEach( el => {
                el.addEventListener( 'click', () => {

                    // Get the target from the "data-target" attribute
                    const target = el.dataset.target;
                    const $target = document.getElementById( target );

                    // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                    el.classList.toggle('is-active');
                    $target.classList.toggle('is-active');
                }) ;
            } );
        }
    }

    initDropDownTogglers() {
        const $dropdownTogglers = document.querySelectorAll( '.dropdown-toggler' );

        $dropdownTogglers.forEach(toggler => {
            toggler.addEventListener( 'click', ( event ) => this.toggleDropdown( event ) );
        });
    }

    /**
     * Toggles a dropdown menu visibility.
     *
     * @param {Event} event A click event.
     */
    toggleDropdown( event ) {
        const target = event.target;
        const containerId = target.getAttribute( 'aria-controls' );
        const dropdownMenu = document.getElementById( containerId );

        this.toggleAriaExpanded( target );
        dropdownMenu.classList.toggle( 'is-hidden-touch' );
        this.toggleAncestorActiveState( target, 'has-dropdown' );
    }

    /**
     * Set the 'is-active' state for an ancestor of an element
     * with the matching class name.
     *
     * @param {HTMLElement} child A child element to start the search from.
     * @param {HTMLElement} className A target class name for the ancestor.
     */
    toggleAncestorActiveState( child, className ) {
        let ancestor = child.parentNode;
        while ( ancestor ) {
            if ( ancestor.classList.contains( className ) ) {
                ancestor.classList.toggle( 'is-active' );
                return;
            }
            ancestor = ancestor.parentNode ? ancestor.parentNode : false;
        }
    }

    /**
     * Get the toggler's aria-expanded current state and set a new opposite state to it.
     * Also set the opened container's aria-hidden state to the new value's opposite.
     *
     * @param {HTMLElement} toggler The toggler element.
     */
    toggleAriaExpanded( toggler ) {
        const ariaExpandedState = toggler.getAttribute( 'aria-expanded' ) === 'false' ? true : false;
        toggler.setAttribute( 'aria-expanded', ariaExpandedState );
    }
}

// Export the singleton.\\
export default new SharedHeader();
